import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './Loading.scss';
export class Loading extends React.Component {
    render() {
        return (_jsx("div", Object.assign({ className: 'loading' }, { children: _jsx("div", Object.assign({ className: 'spinner sphere', id: 'sphere' }, { children: _jsxs("div", Object.assign({ className: 'inner' }, { children: [_jsx("div", { className: 'disc' }), _jsx("div", { className: 'disc' }), _jsx("div", { className: 'disc' })] })) })) })));
    }
}
